import { render, staticRenderFns } from "./LeadCustomerContent.vue?vue&type=template&id=5ba829de&scoped=true"
import script from "./LeadCustomerContent.vue?vue&type=script&lang=ts"
export * from "./LeadCustomerContent.vue?vue&type=script&lang=ts"
import style0 from "./LeadCustomerContent.vue?vue&type=style&index=0&id=5ba829de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba829de",
  null
  
)

export default component.exports